<template>
    <div class="quiz__results">
        <div class="products">
            <h1 class="quiz__results-title">Your Perfect Holiday Gift to Give</h1>

            <div class="recommendations-wrapper">
                <transition-group name="fade" class="recommendations">
                    <product v-for="(product, index) in recommendations" :product="product" :key="index" />
                </transition-group>
            </div>

            <results-ctas :wishlist="recommendation_upcs" />
        </div>
    </div>
</template>

<script>
import Product from './product.vue'
import QuizLogic from '../data/quiz.json'
import ResultsCTAs from './results-ctas.vue'

import { isObject } from '../utilities'

export default {
    components: {
        'product': Product,
        'results-ctas': ResultsCTAs,
    },
    data() {
        return {}
    },
    computed: {
        recommendations() {
            const { who, category, price, lifestyle } = this.$route.params
            const results = QuizLogic[who][category][price][lifestyle]

            const recommendations = results.map((p) => ({ upc: this.formatUPC(p[1]) }))

            if (!results.some((p) => p[1].match(/^0?(?:730852112(?:292|308)|729238139725)$/))) {
                let additional_product = null

                switch (this.$route.params.price.toLowerCase()) {
                    case '$100 + over':
                        additional_product = { upc: '0730852112308' }
                        break
                    case '$50-$100':
                        additional_product = { upc: '0730852112292' }
                        break
                    case 'under $50':
                        additional_product = { upc: '0729238139725' }
                        break
                    default:
                        break
                }

                if (isObject(additional_product)) {
                    recommendations.push(additional_product)
                }
            }

            return recommendations
        },
        recommendation_upcs() {
            return this.recommendations.map(({ upc }) => this.formatUPC(upc))
        },
    },
    created() {},
    methods: {
        formatUPC(upc) {
            if (upc.length < 13) {
                return '0'.concat(upc)
            }

            return upc
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/results.vue